export default "__VITE_ASSET__DIMbvj4J__"